import schedule from "./schedule";

const {
  formField: { schedules, notes }
} = schedule;

const initialValues = {
  [schedules.name]: "",
  [notes.name]: ""
};

export default initialValues;
